import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { StatusPill } from "@/components/StatusPill";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

const TYPES = [
  { v: "late_arrival", l: "Late Arrival" },
  { v: "no_show", l: "No Show" },
  { v: "conduct", l: "Conduct" },
  { v: "safety", l: "Safety" },
  { v: "patient_care", l: "Patient Care" },
  { v: "worker_complaint", l: "Worker Complaint" },
  { v: "facility_complaint", l: "Facility Complaint" },
];

export default function FacilityIncidents() {
  const [incidents, setIncidents] = useState([]);
  const [form, setForm] = useState({ incident_type: "late_arrival", description: "", severity: "medium" });

  const load = () => api.get("/incidents").then((r) => setIncidents(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/incidents", { ...form, facility_id: "auto" });
      toast.success("Incident reported");
      setForm({ incident_type: "late_arrival", description: "", severity: "medium" });
      load();
    } catch { toast.error("Failed to report"); }
  };

  return (
    <div className="space-y-6" data-testid="facility-incidents">
      <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Incident Reports</h1>
      <Card>
        <CardHeader><CardTitle>Report incident</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <Select value={form.incident_type} onValueChange={(v) => setForm({ ...form, incident_type: v })}>
                <SelectTrigger data-testid="incident-type"><SelectValue /></SelectTrigger>
                <SelectContent>{TYPES.map((t) => <SelectItem key={t.v} value={t.v}>{t.l}</SelectItem>)}</SelectContent>
              </Select>
              <Select value={form.severity} onValueChange={(v) => setForm({ ...form, severity: v })}>
                <SelectTrigger data-testid="incident-severity"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="low">Low</SelectItem><SelectItem value="medium">Medium</SelectItem><SelectItem value="high">High</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Textarea placeholder="Describe the incident…" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} required data-testid="incident-desc" />
            <Button type="submit" className="bg-brand-navy hover:bg-brand-blue" data-testid="incident-submit-btn">Submit report</Button>
          </form>
        </CardContent>
      </Card>
      <div className="grid gap-3">
        {incidents.map((i) => (
          <Card key={i.id} data-testid={`incident-${i.id}`}>
            <CardContent className="p-4 flex items-center justify-between">
              <div>
                <div className="font-semibold text-slate-900">{i.incident_type.replace(/_/g, " ")}</div>
                <div className="text-sm text-slate-600 mt-1">{i.description}</div>
              </div>
              <StatusPill status={i.status} />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
